import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldMapDrawComponent } from './field-map-draw.component';
import { CardComponent } from '../../../@theme/components/card/card.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';


@NgModule({
  declarations: [
    FieldMapDrawComponent,
  ],
  exports: [
    FieldMapDrawComponent
  ],
  imports: [
    CommonModule,
    CardComponent,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule
  ]
})
export class FieldMapDrawModule { }
